"use client"

import { MessageCircle } from "lucide-react"
import { useState } from "react"

export function WhatsAppFloat() {
  const phoneNumber = "573135909091"
  const whatsappUrl = `https://wa.me/${phoneNumber}`
  const [isHovered, setIsHovered] = useState(false)

  return (
    <div className="fixed bottom-6 right-6 z-50 animate-fade-in-up">
      {/* Animated ripple rings */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="absolute h-14 w-14 animate-ping rounded-full bg-[#25D366] opacity-20 md:h-16 md:w-16" />
        <div
          className="absolute h-14 w-14 animate-pulse rounded-full bg-[#25D366] opacity-30 md:h-16 md:w-16"
          style={{ animationDelay: "0.5s" }}
        />
      </div>

      {/* Tooltip label */}
      <div
        className={`absolute right-full top-1/2 mr-4 -translate-y-1/2 whitespace-nowrap rounded-lg bg-gray-900 px-4 py-2 text-sm font-medium text-white shadow-lg transition-all duration-300 ${
          isHovered ? "translate-x-0 opacity-100" : "translate-x-2 opacity-0"
        }`}
      >
        ¡Chatea con nosotros!
        <div className="absolute right-0 top-1/2 h-0 w-0 -translate-y-1/2 translate-x-full border-8 border-transparent border-l-gray-900" />
      </div>

      {/* Main button */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="relative flex h-14 w-14 animate-bounce-slow items-center justify-center rounded-full bg-gradient-to-br from-[#25D366] to-[#128C7E] text-white shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-2xl hover:shadow-[#25D366]/50 md:h-16 md:w-16"
        aria-label="Contactar por WhatsApp"
        style={{ animationDelay: "1s" }}
      >
        {/* Glow effect on hover */}
        <div className="absolute inset-0 rounded-full bg-gradient-to-br from-[#25D366] to-[#128C7E] opacity-0 blur-xl transition-opacity duration-300 group-hover:opacity-75" />

        {/* Icon with rotation animation on hover */}
        <MessageCircle
          className={`relative z-10 h-7 w-7 transition-transform duration-300 md:h-8 md:w-8 ${
            isHovered ? "rotate-12 scale-110" : ""
          }`}
        />

        {/* Notification badge */}
        <div className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-xs font-bold text-white shadow-md animate-pulse">
          1
        </div>
      </a>
    </div>
  )
}
